import './Demo.css';
import React, { useContext, useEffect, useState } from 'react';
import { AppBar, Button, Grid, MenuItem, Select, Toolbar, Typography } from '@material-ui/core';
import { demoReducerActions, flowType } from '../../store/DemoContext';
import { useDemo } from '../../store/DemoContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { CartContext } from '../../store/CartContext';
import { getDemoKeys } from '../../helpers/checkout-helpers';

interface Props {}

const FLOWS: { name: string; value: flowType }[] = [
  // {
  //   name: 'With consent (non frictionless)',
  //   value: flowType.consent,
  // },
  {
    name: 'No user interaction required',
    value: flowType.noConsent,
  },
  // {
  //   name: 'Frictionless',
  //   value: flowType.frictionless,
  // },
  {
    name: 'User interaction required leading to acceptance',
    value: flowType.challengeSuccess,
  },
  {
    name: 'User interaction required leading to decline',
    value: flowType.challengeDecline,
  },
  // {
  //   name: 'With success challenge (frictionless)',
  //   value: flowType.challengeFrictionless,
  // },
];

const Demo: React.FC<Props> = () => {
  const { setCart } = useContext(CartContext);
  const {
    state: { flow },
    dispatch,
  } = useDemo();
  const [currentFlow, setFlow] = useState<flowType>(flow);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setCart([]);
    localStorage.removeItem('state');
  }, []);

  useEffect(() => {
    const keys = ['mid', 'appKey', 'appSecret', 'spreedlyKey'];
    const isKeysExist = keys.every(el => !!localStorage.getItem(el) || location.search.includes(el));
    if (!isKeysExist) {
      const newKeys = getDemoKeys();
      // @ts-ignore
      keys.forEach(el => localStorage.setItem(el, newKeys[el]));
    }
  }, []);

  return (
    <div className="demo">
      <AppBar position="sticky" className="Header">
        <Toolbar>
          <Typography variant="h6" className="heading">
            FlexFactor Demo Simulator
          </Typography>
        </Toolbar>
      </AppBar>
      <div className="demo-container">
        <Grid container spacing={3}>
          {/*<Grid item xs={12} sm={3} />*/}
          <Grid item xs={12} sm={6}>
            <label className="label">
              <h1>FlexFactor checkouts demo</h1>
              <h3>Explore different checkout flows</h3>
              <Select
                className="input"
                labelId="flow"
                value={currentFlow}
                onChange={event => {
                  dispatch({ type: demoReducerActions.SET_DEMO, payload: event.target.value });
                  setFlow(event.target.value as flowType);
                }}
              >
                {FLOWS.map(item => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </label>
            {/*<label className="label">*/}
            {/*  <div>Result</div>*/}
            {/*  <Select*/}
            {/*    className="input"*/}
            {/*    labelId="result"*/}
            {/*    value={currentFlow}*/}
            {/*    onChange={event => {*/}
            {/*      dispatch({ type: demoReducerActions.SET_DEMO, payload: event.target.value });*/}
            {/*      setFlow(event.target.value as flowType);*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    {FLOWS.map(item => (*/}
            {/*      <MenuItem key={item.value} value={item.value}>*/}
            {/*        {item.name}*/}
            {/*      </MenuItem>*/}
            {/*    ))}*/}
            {/*  </Select>*/}
            {/*</label>*/}
            <div className="buttons">
              <Button
                className="demo-button"
                variant="outlined"
                onClick={() => navigate('/demo/ladies_outerwear')}
                id="demo"
              >
                Launch Demo
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className="demo-image">
              <img src={`${process.env.PUBLIC_URL}/images/demo.png`} alt="demo" />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Demo;
